import { useTranslation } from 'react-i18next'

import { StopIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Button, ReveniAiButton, Text } from '@reveni-io/reveni-ui'

import AiFeedbackButtons from '../AiFeedbackButtons/AiFeedbackButtons'
import AiImprovementInput from '../AiImprovementInput/AiImprovementInput'
import { aiFlowStates } from '../constants'
import * as Styles from './styles'

const AiFlowActions = ({
  aiFlowState,
  aiButtonLabel,
  onGenerateAiEmail,
  generatingAiEmail,
  onAcceptAiContent,
  onRequestImprovement,
  onDiscardAiContent,
  userInquiry,
  setUserInquiry,
  onCancelGeneration,
  aiEmailGenerationEnabled,
}) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (!aiEmailGenerationEnabled) {
    return null
  }

  if (aiFlowState === aiFlowStates.initial || aiFlowState === aiFlowStates.generating) {
    return (
      <Styles.AiFlowActionsContainer>
        <ReveniAiButton label={aiButtonLabel} onClick={onGenerateAiEmail} loading={generatingAiEmail} />
        {generatingAiEmail && (
          <Button variant="text" size="s" onClick={onCancelGeneration}>
            <StopIcon size={20} weight="fill" color={theme.colors.ai.hover} />
            <Text color={theme.colors.ai.hover}>{t('Parar')}</Text>
          </Button>
        )}
      </Styles.AiFlowActionsContainer>
    )
  }

  if (aiFlowState === aiFlowStates.pendingFeedback) {
    return (
      <AiFeedbackButtons onAccept={onAcceptAiContent} onImprove={onRequestImprovement} onDiscard={onDiscardAiContent} />
    )
  }

  if (aiFlowState === aiFlowStates.improving) {
    return (
      <AiImprovementInput
        value={userInquiry}
        onChange={e => setUserInquiry(e.target.value)}
        onGenerate={onGenerateAiEmail}
        generating={generatingAiEmail}
      />
    )
  }

  return null
}

export default AiFlowActions
